<template>
  <div class="goods-component" :class="{'detail':detail}">
    <div class="image-area">
      <Swiper v-if="detail && value.images.length>1"
              class="swiper" :options="viewOption"
              :slides-per-view="3" :space-between="50">
        <SwiperSlide v-for="(image,index) in value.images" :key="index"
                     class="swiper-item">
          <div class="goods-image"
               @click.stop="$emit('on-detail', index)">
            <img :src="image" alt=""/>
          </div>
        </SwiperSlide>
        <div class="swiper-pagination swiper-number" slot="pagination"></div>
      </Swiper>

      <div v-else class="goods-image"
           @click.stop="$emit('on-detail', value)">
        <img :src="value.master_image" alt=""/>
      </div>
    </div>
    <div class="info-area">
      <div class="goods-name">{{value.name}}</div>
      <div class="goods-info">{{value.subname}}&nbsp;</div>
      <div class="price-btn-area">
        <div class="price-area">
          <!-- 显示原价 -->
          <div class="original_price">
            <template  v-if="promotionPrice.type>0">
            <span>{{$t('goods.label_original')}}</span>
            <s>{{YUAN}}{{value.price|amount}}</s>
            </template>&nbsp;
          </div>
          <!-- 显示折扣价格 -->
          <div class="promotion_price">
            <template v-if="promotionPrice.type>0">
              <span>{{ $t('goods.label_promotion') }}: </span>
              <span class="price">{{ YUAN }}{{ promotionPrice.price }}</span>
              <span> ({{ $tc('goods.discount', promotionPrice.discount)}})</span>
            </template>
            <template v-else>
              <span class="price">{{ YUAN }}{{ promotionPrice.price }}</span>
            </template>
          </div>
          <!-- 显示库存（当库存少于低值时） -->
          <div v-if="detail && value.stock<stockLow">{{$t('goods.label_stock')}}：{{value.stock}}</div>
        </div>
        <div class="btn-area">
          <!-- 显示沽清 -->
          <div v-if="value.stock===0" class="goods-sellout">{{$t('goods.tip_sellout')}}</div>
          <div v-else>
            <!-- 做成slot便于定制，如qrcode -->
            <slot name="btn-buy">
              <template v-if="qrcode">
                <!-- 使用二维码 -->
                <VueQr v-if="buyUrl" :text="buyUrl"
                       :size="200" :margin="0" :logoSrc="logo"></VueQr>
                <span v-else-if="buyUrl===null">{{$t('goods.ph_qrcode')}}</span>
                <span v-else style="color: #ee3f38;">{{$t('goods.tip_qrcode_fail')}}</span>
              </template>
              <Button v-if="btnBuy" class="btn-buy"
                      @click.stop="$emit('on-buy', value)">{{btnBuy}}</Button>
              <!-- 购物车按钮 -->
              <img v-else :src="cartIcon" class="btn-img btn-buy"
                   @click.stop="$emit('on-buy', value)" alt=""/>
            </slot>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    import cartIcon from '@/assets/cart-icon.png';
    import Setting from '@/setting';
    import 'swiper/css/swiper.css';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import VueQr from 'vue-qr';

    export default {
        name: 'MyGoods',
        components: {
            Swiper,
            SwiperSlide,
            VueQr
        },
        props: {
            value: {
                default () {
                    return {
                        id: 0,
                        title: '',
                        info: '',
                        image: '',
                        page: null,
                        type_id: 0,
                        status: 0,
                        price: 295,
                        discount: 0.9
                    };
                }
            },
            detail: Boolean,
            btnBuy: String,
            qrcode: Boolean,
            buyUrl: null
        },
        data () {
            return {
                YUAN: Setting.yuan,
                stockLow: Setting.stockLow,
                discountVal: Setting.convertDiscount,

                cartIcon,
                logo: require('@/assets/qr-icon.svg'),
                viewOption: {
                    loop: false,
                    // autoplay: {
                    //     delay: 3000,
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false
                    // },
                    // 显示分页
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true // 允许分页点击跳转
                    },
                    // 设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
        computed: {
            promotionPrice () {
                const res = {
                    type: 0,
                    price: this.value.price,
                    discount: 100
                }
                let allowDiscount = true
                if (this.value.promotions && this.value.promotions.length > 0) {
                    const promotion = this.value.promotions[0]
                    res.type = 1
                    res.price = promotion.price
                    res.discount = Math.round(res.price * 100 / this.value.price)
                    allowDiscount = promotion.allow_discount
                }
                if (allowDiscount && this.value.discountCode) {
                    res.type = 1
                    res.price -= this.value.discountCode.amount
                    res.discount = Math.round(res.price * 100 / this.value.price)
                }
                if (res.type === 0 && this.value.discount < 1) {
                    res.type = 2
                    res.price = Math.round(this.value.price * this.value.discount)
                    res.discount = Math.round(this.value.discount * 100)
                }
                return res
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss">
  .goods-component {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;

    .image-area {
      width: 100%;

      .goods-image {
        width: 100%;
        height: 0;
        padding-bottom: calc(100%*1/1 - 2px);//1:1为高宽比
        overflow: hidden;
        text-align: center;
        position: relative;
        box-sizing: border-box;
        border: solid 1px #dcdddd;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .info-area {
      width: 100%;
      display: flex;
      flex-direction: column;

      .goods-name {
        line-height: 200%;
        width: 100%;
        font-weight: bold;
        //font-size: 1.2rem;
        //text-overflow:ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .goods-info {
        font-size: 0.8rem;
        text-overflow:ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .price-btn-area{
        flex-grow: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .price-area{
          display: flex;
          flex-direction: column;
          &>div{
            line-height: 150%;
          }
          .original_price {
            color: #aaaaaa;
          }

          .promotion_price{
            font-weight: bold;
          }
          .price {
            color: #ff0606;
          }
        }
      }

      .goods-sellout {
        padding:5px 10px;
        border-radius: 15px;
        font-size: smaller;
        color: white;
        background-color: #707070;
      }
      .btn-buy {
         color: white;
         background-color: #707070;
       }
      .btn-buy:hover{
        opacity: .6;
      }
      .btn-img{
        background:none;
        width: 32px;
        cursor: pointer;
      }
    }
  }

  .detail {
    .swiper-item {
      text-align: center;
      padding: 0;
    }
    .info-area {
      margin-top: 10px;
      font-size: 1.2rem;

      .goods-name {
        font-size: 1.5rem;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .goods-info {
        margin-bottom: 5px;
        white-space: normal;
        // overflow: auto;
        text-overflow:ellipsis;
        max-lines: 2;
      }
      .price-btn-area{
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .btn-buy{
        height: 36px;
        line-height: 32px;
        font-size: 1.2rem;
        font-weight: bold;
        width: auto;
        border-radius: 18px;
      }
      .price{
        font-size: 1.4rem;
      }
    }
  }

  @media screen and (min-width:768px ) {
    .detail {
      .image-area {
        width: 30%;
      }

      .info-area {
        padding: 0 20px;
        width: 70%;
        .btn-buy{
          margin-top:10px;
        }
      }

    }

  }

</style>
